__webpack_public_path__ = typeof window.ONE_ASSETS_URL === 'string' ? `${window.ONE_ASSETS_URL}` : 'https://cdn.oneship.io/assets/h5cdn/'
